'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts';

interface VideoDemoSectionProps {
  className?: string;
}

const VideoDemoSection: React.FC<VideoDemoSectionProps> = ({ className = '' }) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [soundEnabled, setSoundEnabled] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleSoundToggle = () => {
    if (!isHydrated) return;
    setSoundEnabled(!soundEnabled);
  };

  const handlePlayToggle = () => {
    if (!isHydrated) return;
    setIsPlaying(!isPlaying);
  };

  // Chart data for Leads Converted
  const chartData = [
  { year: '2022', value: 45 },
  { year: '2023', value: 72 },
  { year: '2024', value: 95 }];


  return;






























































































































































};

export default VideoDemoSection;